import React from 'react'

function PrivacyP() {
  return (
    <div className='tos-container'>
        <h2 className='TOS-header'> Privacy Policy</h2>
        <p className='TOS'>
        Last Updated: 07/22/2023
        </p>
        <p className='TOS'> 
        Timesync is committed to protecting the privacy and security of your personal information. This Privacy Policy explains how we 
        collect, use, disclose, and safeguard your information when you use our scheduling application. By accessing 
        or using the Application, you agree to the terms of this Privacy Policy. If you do not agree with the practices described in this 
        policy, please do not use the Application.
        </p>
        <h2 className='TOS-subheader'>1. Information We Collect</h2>
        <p className='TOS'>
        1.1. Personal Information: When you create an account and use the Application, we may collect personal information,
        such as your name, email address, and password. Organizational users may also provide additional
        information about their organization.
        </p>
        <p className='TOS'>
        1.2. Appointment Information: In the process of scheduling appointments, clients may provide details related to the appointment,
        which may include the type of service requested, preferred date and time, and any specific notes or comments.
        </p>
        <p className='TOS'>
        1.3. Usage Information: We may collect information about how you use TimeSync, including log data.
        </p>
        <h2 className='TOS-subheader'>2. How We Use Your Information</h2>
        <p className='TOS'>
        2.1. We use the collected information to operate, maintain, and improve TimeSync, facilitate appointment scheduling,
        and enhance user experience.
        </p>
        <p className='TOS'>
        2.2. Personal information may also be used to communicate with you about TimeSync, send important updates, or respond
        to inquiries and support requests.
        </p>
        <p className='TOS'>
        2.3. We may use non-personal and aggregated information for statistical and analytical purposes to understand how users interact
        with TimeSync and improve our services.
        </p>
        <h2 className='TOS-subheader'>3. How We Share Your Information</h2>
        <p className='TOS'>
        3.1. We do not sell or rent your personal information to third parties.
        </p>
        <p className='TOS'>
        3.2. We may share your personal information with the respective organization with which you schedule appointments. This
        information is shared to facilitate the appointment process and provide the requested services.
        </p>
        <p className='TOS'>
        3.3. We may share aggregated and non-personal information with third parties for various purposes, such as marketing,
        analytics, and improving our services.
        </p>
        <p className='TOS'>
        3.4. We may disclose your information to comply with legal obligations, protect our rights and interests, prevent fraud,
        or in response to a government request.
        </p>
        <h2 className='TOS-subheader'>4. Data Security</h2>
        <p className='TOS'>
        4.1. We take appropriate measures to protect your personal information from unauthorized access, alteration, disclosure,
        or destruction. However, no method of transmission over the internet or electronic storage is 100% secure, and we cannot guarantee absolute security.
        </p>
        <h2 className='TOS-subheader'>5. Children's Privacy</h2>
        <p className='TOS'>
        5.1. The Application is not intended for use by individuals under the age of 13. We do not knowingly
        collect personal information from children under this age. If you believe we have inadvertently collected information from a
        child, please contact us, and we will promptly take appropriate action to delete such data.
        </p>
        <h2 className='TOS-subheader'>6. Changes to this Privacy Policy</h2>
        <p className='TOS'>
        6.1. We may update this Privacy Policy from time to time to reflect changes in our practices or for other operational,
        legal, or regulatory reasons. The updated policy will be posted on the Application, and the "Last Updated" date will be revised
        accordingly.
        </p>
    </div>
  )
}

export default PrivacyP